<template>
<ValidationObserver ref="observer">
  <form ref="edit_pool_form" @submit.prevent="handleSubmit(updatePool)">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed Name</label>
                  <md-input v-model="pool.pool_name" required/>
                  <validation-error :errors="apiValidationErrors.pool_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed Address</label>
                  <md-textarea v-model="pool.pool_address" md-autogrow maxlength="100" md-counter="100"></md-textarea>

                  <validation-error :errors="apiValidationErrors.pool_address" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Head</label>
                  <md-select v-model="pool.pool_head_id" required>
                    <md-option v-for="option in options_user_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pool_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Workshop Head</label>
                  <md-select v-model="pool.pool_workshop_head_id" required>
                    <md-option v-for="option in options_workshop_head_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pool_workshop_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content>
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('harus', {
  ...required,
  message: 'Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    name: "edit-pool",
    
    props:{
      data_id:null
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({
      pool: [],
      options_user_list:null,
      options_workshop_head_list: null
    }),

    created() {
      this.getPoolData();
      this.getPoolHead();
      this.getWorkshopHead();
    },


    methods: {

      // fungsi untuk mendapatkan data yang akan di edit dengan id yang dikirim bersamaan dengan route
      async getPoolData(){
        //check apakah id ada di route
        if(this.data_id.id){
          
        //jika ada ambil data dari api
        await this.$store.dispatch("workshop_pool/get", this.data_id.id)
        this.pool = await this.$store.getters["workshop_pool/pool"]
        

        }
        else{
          //jika tidak ada kembali ke list
          this.$parent.$parent.modalCloseEdit();
        }
      },

      async getPoolHead(){
        await this.$store.dispatch("users/list_pool_head")
        this.options_user_list = await this.$store.getters["users/list"]
      },

      async getWorkshopHead(){
        await this.$store.dispatch("users/list_workshop_head")
        this.options_workshop_head_list = await this.$store.getters["users/list"]
      },

      // validasi menggunakan sweetalert  sebelum mengubah data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updatePool(id)
          }
        });
    },


    // fungsi edit
      async updatePool() {
        const data = {
          type: "workshop_pools",
          id: this.pool.id,
          pool_name: this.pool.pool_name,
          pool_head_id: this.pool.pool_head_id,
          pool_workshop_head_id: this.pool.pool_workshop_head_id,
          pool_address: this.pool.pool_address

        }

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_pool/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "data changed successfully.")
          //kembali ke list
          this.$parent.$parent.modalCloseEdit();
        } catch (e) {
          //panggil notifikasi error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
